<app-search-field [(ngModel)]="query" />

<app-checkbox
  class="price"
  [checked]="allChecked"
  [indeterminate]="isIndeterminate"
  (checkedChange)="toggle($event)">
  Select all ({{ count() }})
</app-checkbox>

@if (showCheckboxForEmptyValue) {
  <app-checkbox
    class="price"
    [(ngModel)]="filter.is_null"
    (checkedChange)="updateFilterChangeTime()">
    Empty
  </app-checkbox>
}

@for (checkbox of viewDictionary(); track checkbox.id) {
  <app-checkbox
    class="price"
    [checked]="selectedSet.has(checkbox.id)"
    (checkedChange)="toggleOne(checkbox.id)">
    {{ checkbox.name }}
  </app-checkbox>
}
